import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import {
  CrudMasterDetailView,
  CrudContext,
  GridView,
  MasterDetailForm,
  Widget,
  FormatText,
  FormNumber,
  FormInput,
  FormDatePicker,
  FormSubmitButton,
  Button,
  CompositeView,
} from '@digital/ui';
import { createPlanilhaOrcamento, getAllProjetosFiltroContextoPlanilhaCapex } from '@app/api/projeto';
import UploadFile from '@app/components/uploadFile';
import { exportaModelo } from '@app/api/exportaFile';
import { OrcamentoPlanilha } from '@app/api/ordemInvestimento';
import { GetAllPlanilhaCapexAntigas } from '@app/api/ordemInvestimento';
import { exportaPlanilhaCapexAntiga } from '@app/api/exportaFile';
import { hasPermission } from '@app/helpers/permissions';
import PlanilhaCapexTabela from './PlanilhaCapexTabela';
import TablePlanilha from '../TablePlanilhas';

const PlanilhaCapexComponent = () => {
  const [projetos, setProjetos] = useState(() => getAllProjetosFiltroContextoPlanilhaCapex);
  const [hasFile, setHasFile] = useState(false);
  const [atualizarTela, setAtualizarTela] = useState<boolean>(false);
  const [planilhas, setPlanilhas] = useState<OrcamentoPlanilha[]>();
  const [projetoSelecionado, setProjetoSelectionado] = useState<OrcamentoPlanilha[]>();

  useEffect(() => { });

  const handleCreatePlanilhaOrcamento = (values: any, selectedItem: any) => {
    createPlanilhaOrcamento(selectedItem.id, values.formData, values).then(result => {
      if (result.valid) {
        setHasFile(true);
        setHasFile(false);
        setAtualizarTela(!atualizarTela);
        setProjetos(() => Promise.resolve(undefined));
        setProjetos(() => getAllProjetosFiltroContextoPlanilhaCapex);
      }
    });
  };

  useEffect(() => {
    const getPlanilhasData = async (id: string) => {
      const result = await GetAllPlanilhaCapexAntigas(id);
      if (result) setPlanilhas(result);
    };

    if (projetoSelecionado) getPlanilhasData(projetoSelecionado.id);
  }, [projetoSelecionado]);

  const exportarPlanilha = (item: OrcamentoPlanilha) => {
    if (item) {
      exportaPlanilhaCapexAntiga(item.projetoId, item.nome, item.numero, item.revisao, item.dataAprovacao);
    }
  };

  const validationSchema = Yup.object().shape({
    dataAprovacao: Yup.date().required('Data de Aprovação é obrigatória.'),
  });

  const exportarModelo = (modelo: string) => {
    if (modelo) {
      exportaModelo(modelo);
    }
  };


  return (
    <CrudMasterDetailView
      getAllItems={projetos}
      disableNotification
      icon="business-estimate"
      detailTitleExtractor={x => `PLANILHA ORÇADO CAPEX DO PROJETO ${x.numero}`}
      filterPredicate={(item, value) =>
        item.nome.toLowerCase().includes(value.toLowerCase()) ||
        (item.codigo && item.codigo.toLowerCase().includes(value.toLowerCase())) ||
        (item.statusNome && item.statusNome.toLowerCase().includes(value.toLowerCase())) ||
        item.numero.toLowerCase().includes(value.toLowerCase())
      }
      titleExtractor={item => `${item.codigo} - ${item.nome}`}
      descriptionExtractor={item => item.statusNome || ''}>
      <CompositeView>
        {hasPermission(['Dono', 'ORCADO_ECONOMICO_CAPEX_VISUALIZAR_MENU']) && (
          <CrudContext.Consumer>
            {({ selectedItem }) => {
              setProjetoSelectionado(selectedItem);
              return (
                <GridView noform>
                  {hasPermission(['ORCADO_ECONOMICO_CAPEX_EDITAR_ABA_INDEX']) && (
                    <MasterDetailForm
                      validationSchema={validationSchema}
                      onSubmit={values => {
                        handleCreatePlanilhaOrcamento(values, selectedItem);
                      }}>
                      <Widget
                        title="Importação de planilha"
                        actions={[
                          selectedItem && selectedItem.possuiPlanilhaCapex === true && <> </>,
                          <Button
                            type="link"
                            icon="files-xls"
                            onClick={() => {
                              exportarModelo('modeloOrcadoCapex');
                            }}>
                            Modelo de importação Capex
                          </Button>,
                          hasPermission(['ORCADO_ECONOMICO_CAPEX_EDITAR_ABA_INDEX']) && (
                            <FormSubmitButton type="primary">
                              <FormatText id="ui.commons.save" uppercase />
                            </FormSubmitButton>
                          ),

                        ]}>
                        <FormNumber label="Número" name="numero_planilha" span={4} />
                        <FormInput label="Revisão" name="texto_revisao" span={4} />
                        <FormDatePicker
                          label="Data de Aprovação"
                          name="dataAprovacao"
                          format="DD/MM/YYYY"
                          span={4}
                          required
                        />
                        {selectedItem && hasPermission(['ORCADO_ECONOMICO_CAPEX_EDITAR_ABA_INDEX']) ? (
                          <UploadFile
                            hasFile={hasFile}
                            accept=".xlsx"
                            label="Incluir planilha"
                            id="importFilePlanilha"
                            selectedItem={selectedItem}
                          />
                        ) : (
                          <> </>
                        )}
                      </Widget>
                    </MasterDetailForm>
                  )}
                  {selectedItem && hasPermission(['ORCADO_ECONOMICO_CAPEX_VISUALIZAR_MENU']) ? (
                    <PlanilhaCapexTabela atualizarTelaProp={atualizarTela} projeto={selectedItem} />
                  ) : (
                    <> </>
                  )}
                  {selectedItem &&
                    hasPermission(['ORCADO_ECONOMICO_CAPEX_VISUALIZAR_MENU']) &&
                    (planilhas && planilhas.length > 0) ? (
                    <TablePlanilha dataPlanilhas={planilhas || []} exportarPlanilhaAntiga={exportarPlanilha} />
                  ) : (
                    <> </>
                  )}
                </GridView>
              );
            }}
          </CrudContext.Consumer>
        )}
      </CompositeView>
    </CrudMasterDetailView>
  );
};

export default PlanilhaCapexComponent;
